//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';
    angular
        .module('container.core')
        .factory('templateCacheBusterService', templateCacheBusterService)
        .config(pushInterceptor)
    ;
    function templateCacheBusterService($q, $rootScope, Event) {

        const dateSuffix = (new Date()).getTime();

        let service = {
            authentication: null,
        };

        service.request = config => {

            let d = $q.defer();

            if (config.url.indexOf('.html') !== -1) {
                config.url += '?v=' + dateSuffix;
            }
            d.resolve(config);

            return d.promise;
        };

        return service;
    }

    function pushInterceptor($httpProvider) {
        $httpProvider.interceptors.push('templateCacheBusterService');
    }
})();
